import React from 'react';

const GreyLine = () => {

 return (<div  className="grey-line"></div>)

}

export default GreyLine;